/**
 * The backend's own error message, falling back to a generic label.
 * `StoxlyApiError` (the spine's HTTP error) already extracts the NestJS
 * `message` field into `Error#message`, so plain `Error` handling covers it.
 */
export function apiErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message) return error.message;
  return 'Request failed';
}
